import type React from "react"

export const MarketRailComponentItem = ({ children }: { children: React.ReactNode }) => {
  return <li>{children}</li>
}
